<script>
  import { fade } from 'svelte/transition';
  import { page } from '@inertiajs/svelte';
  import viewport from '@/js/utils/useViewportAction.js';
  import PortfolioWorkSlider from './Slider.svelte';
  import PortfolioGridItem from '../grid/Item.svelte';
  import PortfolioGridMobileItem from '../grid/MobileItem.svelte';

  import responsive from '@/js/utils/responsive';

  export let work;
  let shown = 'grid';
  let grow = false;

  let innerWidth = 0;

  $: mobile = innerWidth <= responsive.s;
</script>

<svelte:window bind:innerWidth />

<section class="section-border-top">
  <div
    class="div container container--large"
    class:grow
    use:viewport
    on:enterViewport={() => (grow = true)}
  >
    <h2 class="h3 text-center work-title">{work.title}</h2>

    <ul class="work-nav">
      <li>
        <button
          class="work-nav__link tagline text-link"
          class:active={shown == 'mockups'}
          on:click|preventDefault={() => {
            shown = 'mockups';
          }}>{$page.props.i18n.page.mockups}</button
        >
      </li>
      <li>
        <button
          class="work-nav__link tagline text-link"
          class:active={shown == 'grid'}
          on:click|preventDefault={() => {
            shown = 'grid';
          }}>{$page.props.i18n.page.grid}</button
        >
      </li>
    </ul>

    <div>
      {#if shown == 'mockups'}
        <div class="work-item" transition:fade>
          <PortfolioWorkSlider items={work.items} />
        </div>
      {/if}
      {#if shown == 'grid'}
        <div class="work-item" transition:fade>
          <div class="work-item__grid flexbox flexbox--grid">
            {#each work.items as item}
              <div class="col col-50 col-m-full">
                {#if mobile}
                  <PortfolioGridMobileItem {item} />
                {:else}
                  <PortfolioGridItem {item} />
                {/if}
              </div>
            {/each}
          </div>
        </div>
      {/if}
    </div>
  </div>
</section>

<style lang="scss">
  @keyframes fade-up {
    0% {
      opacity: 0;
      transform: translateY(30px);
    }

    75% {
      opacity: 0.5;
    }

    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .work-title {
    @include resp-max('s') {
      @include h2;
    }
  }
  .work-nav {
    display: flex;
    gap: 4rem;
    justify-content: center;

    margin: 1.5rem 0 0;

    &__link {
      padding: 1.5rem 0;
      font-weight: bold;
      text-transform: uppercase;

      &::after {
        height: 1.5px;
        background-size: 200%;
        background-position: right;
        opacity: 0;
      }

      &.active {
        color: var(--royal);
        &::after {
          opacity: 1;
        }
      }
    }
  }

  .work-item {
    &__grid {
      @include resp-max('m') {
        padding: 5rem 0 0;
      }
      @include resp-min('m') {
        padding: 5rem 10rem 0;
      }
    }
  }

  .container {
    &.grow {
      animation: fade-up 1s ease-in-out backwards;
    }
  }
</style>
